export default "__VITE_ASSET__CYrxvgpm__"